import { render, staticRenderFns } from "./context-tasks.vue?vue&type=template&id=b52293d2"
import script from "./context-tasks.vue?vue&type=script&lang=js"
export * from "./context-tasks.vue?vue&type=script&lang=js"
import style0 from "./context-tasks.vue?vue&type=style&index=0&id=b52293d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports